import React from 'react'

import clsx from 'clsx'

import Stars from 'components/Stars'
import Typography from 'components/Typography'

import classes from './CriteriaItem.module.scss'

const DEFAULT_LABEL = 'Overall rating'

/** @type {import('./types').default} */
const RatingCriteriaItem = ({
  average = 0,
  className,
  component,
  label = DEFAULT_LABEL,
  labelVariation = 'tight-xs',
  starSize = '16',
  starCenterAlignment = false,
}) => {
  const Component = component || 'div'
  return (
    <Component className={clsx('RatingCriteriaItem', classes.root, className)} data-testid="Rating-CriteriaItem">
      <Typography
        className={clsx(classes.paragraph, { [classes.faded]: average < 0.25 })}
        variant={labelVariation}
        component="span"
      >
        {label}
      </Typography>
      <Stars
        rating={average}
        size={starSize}
        className={clsx(classes.ratingAlignment, { [classes.ratingCenterAlignment]: starCenterAlignment })}
      />
    </Component>
  )
}

export default RatingCriteriaItem
